export default __webpack_public_path__ + "static/media/IQ3 - IQ3 Mini.95d99833.jpg";